import { fixtureOptaEventsPreset } from "@aelive/dds-client";
import { dds } from "./ddsClient";

/**
 * The DDS request for one fixture's raw Opta events (OPUS-1615). `fields` comes from
 * the caption's v_captions["x-dataOptIns"].optaEvents entry; without it, the preset's
 * default fields without qualifiers.
 * @returns {{keys: string[], context: object}}
 */
export function optaEventsRequest({ competitionId, seasonId, fixtureId, fields }) {
  const preset = fixtureOptaEventsPreset({ competition_id: competitionId, season_id: seasonId, fixture_id: fixtureId });
  if (!fields?.length) return preset;
  const teamKeys = (team) => [`fixture.${team}.team_id`, ...fields.map((f) => `fixture.${team}.opta_events.${f}`)];
  return { ...preset, keys: ["fixture.fixture_id", ...teamKeys("home_team"), ...teamKeys("away_team")] };
}

/**
 * One fixture's raw Opta events per team, with only the fields the caption asked for.
 * @returns {Promise<{home: object[], away: object[]}>}
 */
export async function fetchOptaEvents(request) {
  const res = await dds.getStaticData(optaEventsRequest(request));
  const fx = res?.fixture?.[0];
  return {
    home: fx?.home_team?.[0]?.opta_events ?? [],
    away: fx?.away_team?.[0]?.opta_events ?? [],
  };
}

/**
 * A copy of the match data with each team's Opta events laid on it. The live
 * fixtureState is not touched, so patches and the goal recount are unaffected.
 */
export function withOptaEvents(fixtureState, optaEvents) {
  const fx = fixtureState?.fixture?.[0];
  if (!fx || !optaEvents) return fixtureState;
  const withEvents = (team, events) => [{ ...team?.[0], opta_events: events }];
  return {
    ...fixtureState,
    fixture: [
      {
        ...fx,
        home_team: withEvents(fx.home_team, optaEvents.home),
        away_team: withEvents(fx.away_team, optaEvents.away),
      },
      ...fixtureState.fixture.slice(1),
    ],
  };
}
